import { createUseStyles } from '../../theme/theming';
const useSectionStyles = createUseStyles((theme) => ({
  section: {
    position: 'relative',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h2,& h3': {
      marginTop: '0'
    }
  },
  newsLetterContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },

  // partialBackground: {
  //   top: '0',
  //   left: '0',
  //   width: '100%',
  //   height: '50%',
  //   position: 'absolute',
  //   background: theme?.palette?.background?.primary
  // },
  sectionContainer: {
    backgroundColor: theme?.colors?.background2,
    boxShadow: theme?.shadows?.secondary,
    borderRadius: theme?.shape?.borderRadius?.regular,
    padding: theme.spacing.padding.small,
    position: 'relative'
  },
  cardHeading: {
    fontSize: theme.typography.fontSize.h2,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: '71px',
    letterSpacing: '-3px',
    color: theme?.colors?.font3,
    marginBottom: theme.spacing.padding.tiny,
    wordBreak: 'break-word'
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '128px'
  },
  title: {
    fontSize: theme.typography.fontSize.h6,
    lineHeight: '32px',
    color: theme?.colors?.font3,
    wordBreak: 'break-word',
    flex: 1
  },
  inputContainer: {
    display: 'flex',
    flex: 1
  },
  inputFieldDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    marginRight: '-24px'
  },
  btnContainer: {
    flexShrink: '0',
    cursor: 'pointer',
    maxWidth: '100%'
  },
  error: {
    borderBottom: '1px solid red',
    margin: '8px 8px 0px 18px',
    width: 'calc(100% - 26px)'
  },
  errorBorder: {
    border: `1px solid red`,
    color: 'red',
    '&::placeholder': {
      color: 'red',
      opacity: '0.5'
    }
  },

  '@media screen and (max-width: 767px)': {
    section: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    sectionContainer: {
      borderRadius: theme?.shape?.borderRadius?.large,
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column'
    },
    partialBackground: {
      height: '150px'
    },
    title: {
      width: '100%',
      lineHeight: '22px',
      margin: '0px 0px 16px 0px'
    },
    cardHeading: {
      lineHeight: '32px',
      letterSpacing: '-1px',
      width: '50%',
      lineHeight: 'normal'
    },
    contentContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      textAlign: 'center',
      gap: '16px'
    },
    inputContainer: {
      display: 'block',
      width: '100%',
      position: 'initial'
    },
    btnContainer: {
      right: 'unset',
      position: 'initial',
      marginTop: '4px'
    }
  }
}));

export default useSectionStyles;
